import { TextField, Button, Popover, IconButton } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import CloseIcon from '@material-ui/icons/Close';
import { cloneDeep } from 'lodash';
import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import {
    duplicateField,
    getProjectNameOfField,
    isShowDuplicateButton,
    isSystemField,
    onClickUsingProjects,
    onCloseFieldExpandMore,
    removeCurrentGUIAddField
} from '@/component/formManagement/handler/FieldListHandler';
import SettingFormDev from '../SettingFormDev';
import {
    updateParentFieldList,
    isAddNewField,
    onChangeItemInForm,
    onChangeFieldName,
    isUseFieldInForm,
    isFieldError,
    getErrorByField,
    isEditField,
    validateAddFieldNameCustom,
    onChangeFieldNameREF,
    onBlurUpdateField
    
} from '../handler/CommonHandler';
import { duplicateField as duplicateFieldInForm } from '@/component/formManagement/handler/FormListHandler';

import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import BookmarkBorderSharpIcon from '@material-ui/icons/BookmarkBorderSharp';
import BookmarkSharpIcon from '@material-ui/icons/BookmarkSharp';
import DeleteSharpIcon from '@material-ui/icons/DeleteSharp';
import FieldIdCommon from './FieldIdCommon';
import { I18n } from 'aws-amplify';
import IconSettingShowInDrilldown from './common/IconSettingShowInDrilldown';

export default function AddFieldStatus(props) {
    // more action popover
    const [moreActionPopover, setMoreActionPopover] = useState(null);
    const isOpenMoreActionPopover = Boolean(moreActionPopover);

    const indexAddField = Utils.findIndexInArrayById(props.currentAddField.id, props.fieldAddList);

    // const currentFieldData = props.fieldAddList[indexAddField];

    const [currentFieldData, setCurrentFielData] = useState(props.fieldAddList[indexAddField]);

    const [isUsingProject, setIsUsingProject] = useState(
        Utils.isEmpty(currentFieldData?.usingProjects)
            ? false
            : currentFieldData.usingProjects.includes(props.projectDetail.id)
    );
    const [isUsingForm, setIsUsingForm] = useState(
        Utils.isEmpty(currentFieldData?.isUsingForm) ? false : currentFieldData.isUsingForm
    );

    const fieldRef = useRef('');

    const argsAll = {
        ...props,
        indexAddField,
        currentFieldData,
        isUsingProject,
        isUsingForm
    };

    useEffect(() => {
        setCurrentFielData(props.fieldAddList[indexAddField]);
    }, [props.fieldAddList[indexAddField]]);

    /** handler enter text input */
    const onEnterTextInput = event => {
        let textValue = event.target.value;
        let isValidate = validateAddFieldNameCustom(textValue, argsAll);
        // if event diff enter then return
        if(isValidate && props.isChangeData === false){
            props.setIsChangeData(true);
        }
        if (event.key !== 'Enter' || isValidate) {
            return;
        }

        let newName = {
            jp: {
                A: 'F',
                text: textValue
            }
        };
        // Update props.currentAddField
        props.currentAddField.name = newName;

        // reset fieldType selected
        let fieldTypeSelectedList = [...props.fieldTypeSelectedList];
        fieldTypeSelectedList = Utils.removeItemInArrayById(
            props.currentAddField.id,
            fieldTypeSelectedList
        );
        props.setFieldTypeSelectedList(fieldTypeSelectedList);

        props.fieldAddList[indexAddField].name = newName;
        props.fieldAddList[indexAddField].usingProjects = isUsingProject
            ? [props.projectDetail.id]
            : [];
        props.fieldAddList[indexAddField].isUsingProject = isUsingProject;
        props.fieldAddList[indexAddField].isErrorValidate = false;
        props.fieldAddList[indexAddField].isShowInfo = false;

        // update in field list or dragdrop data
        updateParentFieldList(props, currentFieldData, newName, isUsingProject);
    };

    // Change to step 2, add item of status field
    /** handler addOptions */
    const onAddOptions = event => {
        if (currentFieldData.definition === Constant.FORM_DEFINITION.SYSTEM) {
            return;
        }
        props.setPanelScreen(Constant.FORM_MANAGEMENT_SCREEN.ADD_FIELD_STATUS_ITEM);
        props.setCurrentUpdateField(props.fieldAddList[indexAddField]);
    };

    const isShowEditSelection = () => {
        let fieldListAddToForm = Utils.isEmptyArray(props.listFieldAddToForm) ? [] : [...props.listFieldAddToForm];
        let showEditSelection =  true;
        const prefixId = Utils.getPrefixOfId(props.currentAddField.id);
        if ((props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM ||
            props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM) &&
            prefixId !== 'dummy'
        ) {
            let cloneFieldAddToForm = cloneDeep(fieldListAddToForm);
            const indexFieldAddToForm = Utils.findIndexInArrayById(props.currentAddField.id, cloneFieldAddToForm);
            if (indexFieldAddToForm === -1) {
                showEditSelection = false;
            }
        }
        return showEditSelection;
    }

    // update ref
    useEffect(() => {
        if (!Utils.isEmpty(currentFieldData) && !Utils.isEmpty(props.fieldRefList)) {
            props.fieldRefList[currentFieldData.id] = fieldRef;
        }
    });

    const handleOnChangeFieldName = (e, args) => {
        let currentFieldDataClone = {...currentFieldData};
        currentFieldDataClone = onChangeFieldNameREF(e, currentFieldDataClone, args);
        setCurrentFielData(currentFieldDataClone);
    }

    const onChangeAllowCustomerChangeStatus = (e) => {
        props.setIsAllowCustomerChangeStatus(!props?.isAllowCustomerChangeStatus);
        props.setIsChangeData(true);
    };

    return (
        <>
            {indexAddField === -1 ? (
                <></>
            ) : (
                <li
                    id={currentFieldData.id}
                    ref={fieldRef}
                    className={isUseFieldInForm(currentFieldData, props.formList, argsAll)? "listField-li":"listField-li background-color-usingForm"}
                    key={currentFieldData.id}
                    style={{ width: '100%' }}
                >
                    <div
                        className={
                            isUseFieldInForm(currentFieldData, props.formList, argsAll)
                                ? 'fieldSetting-info fieldSetting-info--changeForm'
                                : 'fieldSetting-info fieldSetting-info--changeForm background-color-usingForm'
                        }
                    >
                        <div className="fieldSetting-thumb">
                            <img src="/assets/image/icon-field.svg" alt="" />
                        </div>
                        <div className="fieldSetting-cmt">
                            <div className="fieldSetting-name">
                                <div className="formCreate">
                                    <TextField
                                        className="form-input-outlined form-disable-enter"
                                        placeholder="フィールド名"
                                        onKeyPress={onEnterTextInput}
                                        // onChange={e => onChangeFieldName(e, argsAll)}
                                        onChange={e => handleOnChangeFieldName(e, argsAll)}
                                        defaultValue={Utils.getTextByLanguage(
                                            Constant.LANGUAGE_TYPE.JP,
                                            currentFieldData.name
                                        )}
                                        disabled={isEditField(currentFieldData, argsAll)}
                                        error={isFieldError('name', currentFieldData)}
                                        helperText={getErrorByField('name', currentFieldData)}
                                        onBlur={e => onChangeFieldName(e, argsAll)}
                                        // onBlur={e => onBlurUpdateField(currentFieldData, argsAll)}
                                    />
                                </div>
                                <p className="fieldSetting-text">
                                    {getProjectNameOfField(currentFieldData, props.projectList)}
                                </p>
                            </div>
                            <div className="fieldSetting-autofill">
                                <div
                                    className={
                                        isUseFieldInForm(currentFieldData, props.formList, argsAll)
                                            ? 'fieldSetting-item'
                                            : 'fieldSetting-item background-color-usingForm'
                                    }
                                >
                                    {
                                        !isAddNewField(currentFieldData) && argsAll.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.LIST_FIELD && (
                                            <IconSettingShowInDrilldown
                                                field={currentFieldData}
                                                fieldList={props?.fieldList}
                                                setFieldList={props?.setFieldList}
                                                fieldAddList={props?.fieldAddList}
                                                setFieldAddList={props?.setFieldAddList}
                                                setIsChangeData={props?.setIsChangeData}
                                            />
                                        )
                                    }

                                    {/* <IconButton
                                        className="itemTools"
                                        onClick={event => {
                                            setMoreActionPopover(null);
                                            removeCurrentGUIAddField(props);
                                        }}
                                    >
                                        <img src="/assets/image/icon-tabs-delete.svg" alt="" />
                                    </IconButton> */}
                                    {!props.disableBtnShowMore && (
                                        <IconButton
                                            className="itemTools itemTools-arrow"
                                            onClick={e =>
                                                onCloseFieldExpandMore(props, currentFieldData)
                                            }
                                        >
                                            <img
                                                src="/assets/image/icon-arrow-accordion-gray.svg"
                                                alt=""
                                            />
                                        </IconButton>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="fieldSetting-content">
                        {!isSystemField(currentFieldData) && isShowEditSelection() && (
                            <>
                                <FieldIdCommon fieldId={props.currentAddField?.id}/>
                                <div className={`setting-toggle-item ${props.addFormType === Constant.FORM_TYPE.FORM_REQ_QA ? '':'displayNone'}`}>
                                    <label className="setting-label">{I18n.get('LABEL-ALLOW-CUSTOMER-TO-CHANGE_COMPLETE-STATUS')}</label>
                                    <div className="switch-check">
                                        <input
                                            type="checkbox"
                                            id={`switch-done-by-customer-mode`}
                                            defaultChecked={props?.isAllowCustomerChangeStatus}
                                            onChange={onChangeAllowCustomerChangeStatus}
                                        />
                                        <label htmlFor={`switch-done-by-customer-mode`}></label>
                                    </div>
                                </div>
                                <div className="editSelection">
                                    <a className="editSelection-text" href="javascript:void(0)" onClick={onAddOptions}>
                                        <span
                                            className="itemEdit"
                                            variant="contained"
                                            color="primary"
                                            data-cy="add-item-status-btn"
                                        >
                                            <img src="/assets/image/icon-editSelection.svg" alt="" />
                                        </span>
                                        ステータス編集
                                    </a>
                                </div>
                            </>
                        )}
                    </div>
                    {(props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.ADD_FORM ||
                        props.parentPanelScreen === Constant.FORM_MANAGEMENT_SCREEN.EDIT_FORM) && (
                        <SettingFormDev {...props} />
                    )}
                </li>
            )}
        </>
    );
}
